import React, { useState, useEffect } from 'react'
import {
    getAdminMasterPincodeListByFilters,
    updateAdminMasterPincodeStatus,
    DeleteAdminMasterPincodeData,
} from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
import AddEditPincode from './AddEditPincode'
import { Pagination } from '@mui/material'

const PAGE_SIZE = 10

export default function Main() {
    // ─── State ────────────────────────────────────────────────────────────
    const [loader, setLoader] = useState(false)
    const [popupState, setPopupState] = useState(false)
    const [popupStatus, setPopupStatus] = useState('')

    const [pincodeList, setPincodeList] = useState([])
    const [totalPages, setTotalPages] = useState(0)
    const [totalRecords, setTotalRecords] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)

    const [searchQuery, setSearchQuery] = useState('')
    const [filterActive, setFilterActive] = useState('')   // '' | 'true' | 'false'

    const [viewMode, setViewMode] = useState('table')      // 'table' | 'addEdit'
    const [editData, setEditData] = useState({})



    // ─── Helpers ──────────────────────────────────────────────────────────
    const removePopup = () => {
        setTimeout(() => {
            setPopupState(false)
            setPopupStatus('')
        }, 3000)
    }

    const closePopup = () => setPopupState(false)

    const showPopup = (msg) => {
        setPopupStatus(msg)
        setPopupState(true)
        removePopup()
    }

    // ─── Data Fetching ────────────────────────────────────────────────────
    const fetchList = (pageNo = 0, search = searchQuery, active = filterActive) => {
        setLoader(true)
        getAdminMasterPincodeListByFilters(pageNo, PAGE_SIZE, search, active, callback => {
            setLoader(false)
            if (callback && callback.data) {
                setPincodeList(callback.data)
                setTotalPages(callback.totalPages || 0)
                setTotalRecords(callback.totalRecords || 0)
                setCurrentPage(callback.currentPage || 0)
            } else {
                setPincodeList([])
                setTotalPages(0)
                setTotalRecords(0)
                setCurrentPage(0)
                showPopup('Error fetching data!')
            }
        })
    }

    useEffect(() => {
        fetchList(0, '', '')
    }, [])

    // ─── Search / Filter ──────────────────────────────────────────────────
    const handleSearch = () => {
        setCurrentPage(0)
        fetchList(0, searchQuery, filterActive)
    }

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') handleSearch()
    }

    const handleFilterChange = (e) => {
        const val = e.target.value
        setFilterActive(val)
        setCurrentPage(0)
        fetchList(0, searchQuery, val)
    }

    const handleRefresh = () => {
        setSearchQuery('')
        setFilterActive('')
        setCurrentPage(0)
        fetchList(0, '', '')
    }

    // ─── Pagination ───────────────────────────────────────────────────────
    const handlePageChange = (newPage) => {
        if (newPage < 0 || newPage >= totalPages) return
        setCurrentPage(newPage)
        fetchList(newPage, searchQuery, filterActive)
    }

    const handleMuiPageChange = (_, value) => {
        // MUI Pagination is 1-indexed; API is 0-indexed
        handlePageChange(value - 1)
    }

    // ─── Toggle Status ────────────────────────────────────────────────────
    const handleToggle = (item) => {
        const newStatus = !item.isActive
        setLoader(true)
        updateAdminMasterPincodeStatus(item.id, newStatus, callback => {
            setLoader(false)
            if (callback && (callback.message === 'success' || callback.status === 'success' || callback === 'success')) {
                fetchList(currentPage)
            } else {
                showPopup(callback?.message || 'Toggle failed, please try again!')
                fetchList(currentPage)
            }
        })
    }

    // ─── Add / Edit ───────────────────────────────────────────────────────
    const handleAdd = () => {
        setEditData({})
        setViewMode('addEdit')
    }

    const handleEdit = (item) => {
        setEditData(item)
        setViewMode('addEdit')
    }

    const handleAddEditSave = () => {
        setViewMode('table')
        setEditData({})
        fetchList(currentPage)
    }

    // ─── Delete ───────────────────────────────────────────────────────────
    const handleDelete = (id) => {
        setLoader(true)
        DeleteAdminMasterPincodeData(id, callback => {
            setLoader(false)
            if (callback && (callback.message === 'success' || callback.status === 'success' || callback === 'success' || callback.id)) {
                showPopup('Deleted successfully!')
                const newPage = (pincodeList.length === 1 && currentPage > 0) ? currentPage - 1 : currentPage
                setCurrentPage(newPage)
                fetchList(newPage)
            } else {
                showPopup(callback?.message || 'Delete failed, please try again!')
                fetchList(currentPage)
            }
        })
    }

    // ─── Render ───────────────────────────────────────────────────────────
    return (
        <>
            {loader ? <Loader /> : ''}
            {popupState ? <Popup closePopup={closePopup} popupStatus={popupStatus} /> : ''}



            <div className="container Executor">

                {/* ════════ TABLE VIEW ════════ */}
                {viewMode === 'table' && (
                    <>
                        <h3 className="heading">Master Pincode</h3>

                        {/* ── Toolbar ── */}
                        <div
                            className="FilterFields"
                            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}
                        >
                            <div className="inputs" style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
                                <div className="Searchgrp">
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ width: '230px' }}
                                        placeholder="Search pincode / city / state…"
                                        value={searchQuery}
                                        onChange={e => setSearchQuery(e.target.value)}
                                        onKeyDown={handleSearchKeyDown}
                                    />
                                </div>
                                <button className="searchbtn" onClick={handleSearch} title="Search">
                                    <i className="fa fa-search fa-lg" aria-hidden="true"></i>
                                </button>

                                <select
                                    className="form-control"
                                    style={{ width: '130px', height: '38px' }}
                                    value={filterActive}
                                    onChange={handleFilterChange}
                                >
                                    <option value="">All Status</option>
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </select>

                                <button className="searchbtn" onClick={handleAdd} title="Add Pincode">
                                    <i className="fa fa-plus fa-lg" aria-hidden="true"></i>
                                </button>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                {totalRecords > 0 && (
                                    <span style={{ fontSize: '13px', color: '#555' }}>
                                        Total: <strong>{totalRecords}</strong> records
                                    </span>
                                )}
                                <div className="RefreshBtn">
                                    <button className="Refreshbtns" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </div>
                        </div>

                        {/* ── Table ── */}
                        {pincodeList.length > 0 ? (
                            <>
                                <div style={{ background: '#f2f2f2', padding: '10px', borderRadius: '5px', overflow: 'auto', marginTop: '10px' }}>
                                    <table className="table-logs" style={{ marginBottom: '10px', width: '100%' }}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Pincode</th>
                                                <th>Nearby Area</th>
                                                <th>HQ Pincode</th>
                                                <th>Spoke Location</th>
                                                <th>Hub</th>
                                                <th>State</th>
                                                <th>Distance (km)</th>
                                                <th style={{ width: '80px' }}>Active</th>
                                                <th>Edit</th>
                                                <th>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pincodeList.map((item, index) => (
                                                <tr key={item.id || index} style={{ background: '#fff', borderRadius: '5px' }}>
                                                    <td>{currentPage * PAGE_SIZE + index + 1}</td>
                                                    <td>{item.pincode}</td>
                                                    <td>{item.nearbyArea || '—'}</td>
                                                    <td>{item.hqPincode || '—'}</td>
                                                    <td>{item.spokeLocation || '—'}</td>
                                                    <td>{item.hub || '—'}</td>
                                                    <td>{item.state || '—'}</td>
                                                    <td>{item.distanceFromSpoke != null ? item.distanceFromSpoke : '—'}</td>
                                                    <td style={{ width: '80px' }}>
                                                        <div
                                                            className={`togglebtn ${item.isActive ? 'active' : 'inactive'}`}
                                                            style={{ width: '100%', cursor: 'pointer' }}
                                                            onClick={() => handleToggle(item)}
                                                            title={item.isActive ? 'Click to deactivate' : 'Click to activate'}
                                                        >
                                                            <button className="btn" style={{ padding: '8px' }}></button>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <i
                                                            className="fa fa-pencil-square-o fa-lg"
                                                            aria-hidden="true"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => handleEdit(item)}
                                                            title="Edit"
                                                        ></i>
                                                    </td>
                                                    <td>
                                                        <i
                                                            className="fa fa-trash-o fa-lg"
                                                            aria-hidden="true"
                                                            style={{ cursor: 'pointer', color: '#d9534f' }}
                                                            onClick={() => handleDelete(item.id)}
                                                            title="Delete"
                                                        ></i>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* ── MUI Pagination ── */}
                                {totalPages > 1 && (
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                                        <Pagination
                                            count={totalPages}
                                            page={currentPage + 1}
                                            onChange={handleMuiPageChange}
                                            color="primary"
                                            showFirstButton
                                            showLastButton
                                        />
                                    </div>
                                )}
                            </>
                        ) : (
                            !loader && (
                                <p className="text-center" style={{ marginTop: '60px', color: '#888' }}>
                                    No pincode records found.
                                </p>
                            )
                        )}
                    </>
                )}

                {/* ════════ ADD / EDIT VIEW ════════ */}
                {viewMode === 'addEdit' && (
                    <AddEditPincode
                        editData={editData}
                        handleSavebtn={handleAddEditSave}
                    />
                )}

            </div>
        </>
    )
}
